import { render, staticRenderFns } from "./ValidationofPhotometer.vue?vue&type=template&id=85066f6c&scoped=true&"
import script from "./ValidationofPhotometer.vue?vue&type=script&lang=js&"
export * from "./ValidationofPhotometer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85066f6c",
  null
  
)

export default component.exports